export default __webpack_public_path__ + "static/media/swim_suite.05264a92.png";